// Human labels for backend enums (ticket 125). Every <Select> over one of these
// enums and every place that renders the raw value reads from here — never
// `.replace('_', ' ')` inline. Keys mirror backend/models.py and models_mortgage.py.

// Lead.loan_type — models.py LoanTypeLit
export const LOAN_TYPE_LABELS = {
  purchase: 'Purchase',
  refinance: 'Refinance',
  cash_out: 'Cash-Out Refinance',
  heloc: 'HELOC',
  construction: 'Construction',
  commercial: 'Commercial',
  investment: 'Investment Property',
  other: 'Other',
};

// Loan file loan_program — models.py LoanProgram (losApi.PROGRAM_LABELS re-exports this)
export const LOAN_PROGRAM_LABELS = {
  conventional: 'Conventional', fha: 'FHA', va: 'VA', usda: 'USDA', jumbo: 'Jumbo',
  non_qm: 'Non-QM', heloc: 'HELOC', construction: 'Construction',
};

// Loan file loan_purpose — models.py LoanPurpose
export const LOAN_PURPOSE_LABELS = {
  purchase: 'Purchase', rate_term_refi: 'Rate/Term Refinance', cash_out_refi: 'Cash-Out Refinance',
  construction: 'Construction', heloc: 'HELOC', other: 'Other',
};

// Mortgage opportunity loan_type — models_mortgage.py LoanType
export const OPP_LOAN_TYPE_LABELS = {
  conventional: 'Conventional', fha: 'FHA', va: 'VA', usda: 'USDA', jumbo: 'Jumbo',
  non_qm: 'Non-QM', dscr: 'DSCR', commercial: 'Commercial', other: 'Other',
};

// Mortgage opportunity loan_purpose — models_mortgage.py LoanPurpose
export const OPP_LOAN_PURPOSE_LABELS = {
  purchase: 'Purchase', refinance: 'Refinance', cash_out: 'Cash-Out Refinance',
  heloc: 'HELOC', construction: 'Construction', other: 'Other',
};

// models.py Occupancy
export const OCCUPANCY_LABELS = { primary: 'Primary Residence', second_home: 'Second Home', investment: 'Investment' };

// models.py PropertyType (loan files + RE transactions)
export const PROPERTY_TYPE_LABELS = {
  sfr: 'Single Family', condo: 'Condo', townhouse: 'Townhouse', '2_4_unit': '2-4 Unit',
  multi_family: 'Multi-Family', manufactured: 'Manufactured', coop: 'Co-op', pud: 'PUD',
};

// partners_router.py PartnerKind
export const PARTNER_KIND_LABELS = {
  realtor: 'Realtor', builder: 'Builder', cpa: 'CPA', attorney: 'Attorney',
  financial_planner: 'Financial Planner', insurance: 'Insurance', other: 'Other',
};

// Label for a key; unmapped keys degrade to 'Snake case' → 'Snake case' (first letter
// upper, underscores → spaces) so a new backend value never renders as raw 'cash_out'.
// null/undefined/'' → ''.
export function labelFor(map, key) {
  if (key == null || key === '') return '';
  const hit = map && Object.prototype.hasOwnProperty.call(map, key) ? map[key] : null;
  if (hit) return hit;
  const s = String(key).replace(/_/g, ' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// [[key, label], …] in map order — the shape SelectFld / SelectField / SF already take.
export const optionsFrom = (map) => Object.entries(map);
